export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-br from-primary-600 via-primary-700 to-primary-800 rounded-2xl overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center">
            <div className="flex-1 p-8 md:p-12 lg:p-14 text-center lg:text-left">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-white mb-3">
                随时随地，下拉即读
              </h2>
              <p className="text-white/80 text-sm md:text-base leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
                刃牙漫画针对手机阅读深度优化。打开浏览器即可畅享下拉式阅读体验，无需下载任何APP。无论是在地铁、午休还是睡前，随时随地免费看刃牙漫画全集。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <div className="flex items-center gap-2 px-5 py-3 bg-white rounded-xl shadow-lg cursor-pointer">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-smartphone-line text-primary-600 text-lg"></i>
                  </div>
                  <span className="text-sm font-semibold text-foreground-900 whitespace-nowrap">手机浏览器打开即可阅读</span>
                </div>
                <div className="flex items-center gap-2 px-5 py-3 bg-white/15 rounded-xl border border-white/20 cursor-pointer backdrop-blur-sm">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-qr-code-line text-white text-lg"></i>
                  </div>
                  <span className="text-sm font-medium text-white whitespace-nowrap">扫码收藏到手机</span>
                </div>
              </div>
            </div>
            <div className="flex-shrink-0 w-full lg:w-[320px] xl:w-[380px] px-8 md:px-12 lg:px-0 lg:pr-14 pb-8 lg:pb-0">
              <div className="relative mx-auto w-[200px] lg:w-full">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20smartphone%20mockup%20displaying%20a%20manga%20reading%20interface%20with%20warm%20tones%2C%20vertical%20scrolling%20comic%20layout%2C%20clean%20minimal%20UI%2C%20Japanese%20comic%20art%20inside%20screen%2C%20warm%20ambient%20light%2C%20modern%20device%20presentation%2C%20cozy%20reading%20atmosphere&width=600&height=1000&seq=baki-app-mockup&orientation=portrait"
                  alt="刃牙漫画手机阅读界面 - 下拉式即时阅读"
                  className="w-full h-auto rounded-2xl shadow-2xl"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}